import { render, staticRenderFns } from "./DashboardInstitution.vue?vue&type=template&id=516bff27&scoped=true"
import script from "./DashboardInstitution.vue?vue&type=script&lang=js"
export * from "./DashboardInstitution.vue?vue&type=script&lang=js"
import style0 from "./DashboardInstitution.vue?vue&type=style&index=0&id=516bff27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516bff27",
  null
  
)

export default component.exports